import { Big as BigJs } from 'big.js';

BigJs.DP = 10;
BigJs.RM = BigJs.roundHalfUp;

export const Big = BigJs;
